import { render, staticRenderFns } from "./manPowerHrvec.vue?vue&type=template&id=4d8b98b0&scoped=true&"
import script from "./manPowerHrvec.vue?vue&type=script&lang=js&"
export * from "./manPowerHrvec.vue?vue&type=script&lang=js&"
import style0 from "./manPowerHrvec.vue?vue&type=style&index=0&id=4d8b98b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8b98b0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VIcon})
